<template>
  <div id="Container_ScheduleBlockingTimesDetails">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="'Scheduler Blocking Times Details'" />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                  v-bind:Label="$tc('Shared.Therapist')"
                  v-bind:Options="TherapistList"
                  v-bind:ModelArray="Teamcode"
                  v-bind:FieldDescription="'employeeName'"
                  v-bind:FieldCode="'employeeCode'"
                  v-bind:Placeholder="selectPlaceholder"
                  v-bind:Multiple="false"
                  v-bind:RequireEvent="true"
                  v-bind:IfUsevalidation="false"
                  :Input="ChangeDropDownTherapist"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Description')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="255"
                    v-bind:Name="'description'"
                    v-model="resTimeAll.description"
                    v-bind:Id="'Description'"
                />
            </b-col>
        </b-row>

        <MdEditableGrid
            :ref="'editableGrid'"
            :columns="columnsDetail"
            :rows="detail"
            :showMessageIsEmpty="ShowMessageIsEmpty"
            :serverSidePagination="true"
            :showAdd="true"
            :showDelete="true"
            :showSelectAll="true"
            :showSearch="false"
            :totalRows="totalDetailRows"
            :currentPage="currentDetailPage"
            :perPage="perDetailPage"
            :pageOptions="pageOptions"
            :pageChanged="pageDetailChanged"
            :perPageFunction="PerPageDetailFunction"
            :appendNewRows="appendDetailRows"
            :addActionButton="addActionButton"
            :deleteActionButton="deleteDetailActionButton"
            :dataKey="'recordid'"
            @cell-edit-complete="onDetailCellEditComplete"
            @select-row="onRowDetailSelected">
        </MdEditableGrid>

        <div class="space-actions"></div>
        <div class="page-actions">
        <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="onClick"/>
        <MdButton
            v-bind:Label="$t('Shared.Save')"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="saveEditableGrid"/>
        </div>


  </div>
</template>

<script>
    import ShowMessage from '@/components/messages/ShowMessage.js';
    import DBFunctions from '@/common/DBFunctions.js';
    import CalendarResTimeAllocationDetails from '@/services/calendarrestimeallocationdetails.service'
    import EnumService from '@/services/enum.service';
    import Utils from "@/common/utils";
    import { EventBus } from '@/event-bus.js';
    import CalendarResourcesService from '@/services/calendarresources.service'
    import CalendarResTimeAllocations from '@/services/calendarrestimeallocations.service';
    export default {

        beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
            title: this.$tc('ChargeSheet.ChargeSheet'),
            okTitle: this.$t('Shared.BtnCancel'),
            cancelTitle: this.$t('Shared.BtnDismiss'),
            footerClass: 'p-2',
            titleClass: 'modal-title modal-type-warning'
            })
            .then(value => {
                if(!value){
                    next();
                }
            })
        } else {
            next()
        }
        },
        mixins: [ShowMessage, DBFunctions],
        name: 'ScheduleBlockingTimesDetails',
        data(){
        return {
          items:[],
          HeaderDetail: {},
          ShowMessageIsEmpty:false,
          pageOptions: [5,10,20,30,40,50],
          totalDetailRows: 0,
          currentDetailPage: 1,
          perDetailPage: 10,
          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,
              favButtonAtion:false
            },
          columnsDetail: [
            {
              key: 'transdate',
              label: this.$t('Shared.Date'),
              dataType: 'date',
              editable: true
            },
            {
              key: 'timefrom',
              label: this.$t('MdCurrentAppointment.StarTime'),
              dataType: 'time',
              editable: true
            },
            {
              key: 'timeto',
              label: this.$t('MdCurrentAppointment.EndTime'),
              dataType: 'time',
              editable: true
            },
            {
              key: 'status',
              label: this.$t('Shared.Status'),
              dataType: 'dropdown',
              editable: false,
              focusable: true,
              props: {
                options: EnumService.BlockingTimesStatus,
                optionKey: 'value',
                optionValue: 'text'
              }
            },
          ],
          deleteDetailActionButton: {
            visible: true,
            handler: this.deleteItem
          },
          addActionButton: {
            handler: this.addItem
          },
          DetailSearchCriteria: '',
          showMessageIsEmpty: false,
          selectPlaceholder: this.$t('Shared.SelectOptions'),
          detail: [],
          detailSelected: [],
          selectedRows: [],
          updatesToSave:[],
          resTimeAll: [],
          TherapistList:[],
          fullParam: {
            PageSize:0,
            PageNumber:0
          },
          Teamcode: {},
          pendingResTimeAlloc: false
        };
      },

      computed: {
        editableGrid() {
            return this.$refs.editableGrid;
        }
      },

      methods: {

        async getEmployees() {
            await CalendarResourcesService.getAll(this.fullParam)
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){
                        this.TherapistList = response.data;
                    }
                })
                .catch(error => {
                    if (!error.response) {
                    // network error
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                    } else {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
        },

        addItem() {
            this.pendingChanges = true;
        },

        deleteItem(item) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteAllRecord'), {
                    title: this.$tc('Shared.DelRecord', 2),
                    okTitle: this.$t('Shared.TitleDeleteAll'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (value) {
                        if (item && item.length > 0) {
                        item.forEach(async el => {

                            const idsToRemove =
                            this.selectedRows.length > 0
                                ? this.selectedRows.map(row => row.recordid)
                                : [el.recNo];

                            this.detail = this.detail.filter(row => !idsToRemove.includes(row.recordid));
                            this.selectedRows = [];
                            await this.deleteDetail(el.recordid)
                        });
                        await this.GetDetails();
                    } else {

                        const idsToRemove =
                        this.selectedRows.length > 0
                            ? this.selectedRows.map(row => row.recordid)
                            : [item.recordid];

                        this.detail = this.detail.filter(row => !idsToRemove.includes(row.recordid));
                        this.selectedRows = [];
                        this.deleteDetail(item.recordid)
                    }
                    }
                });
        },


        async deleteDetail(recordid) {
            await CalendarResTimeAllocationDetails.Delete(recordid)
                .then(() => {
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        async updateDetail(data) {
            await CalendarResTimeAllocationDetails.UpdateMultiple(data)
                .then(() => {

                    this.pendingChanges = false;
                    setTimeout(
                        () =>
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: 'success'
                            }),
                        50
                    );
                    this.GetDetails();
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        async insertDetail(data) {
            await CalendarResTimeAllocationDetails.Add(data)
                .then(() => {
                    this.pendingChanges = false;
                    this.GetDetails();
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        updateValues(rowKey) {
            const index = this.updatesToSave.findIndex(x => x.recordid == rowKey);
            const row = this.detail.find(x => x.recordid == rowKey);

            this.pendingChanges = true;
            if (index === -1) {
                this.updatesToSave.push(row);
                return;
            } else {
                this.updatesToSave.splice(index, 1)
                this.updatesToSave.push(row);
            }
        },

        async saveEditableGrid() {
            this.saving = true;
            let updateList =  []

            this.updatesToSave.forEach(el => {
                el.timefrom = Utils.isValidDate(el.timefrom) ? Utils.formatTime(el.timefrom) : el.timefrom
                el.timeto = Utils.isValidDate(el.timeto) ? Utils.formatTime(el.timeto) : el.timeto
                updateList.push(el)
            });

            if (await this.editableGrid.save()) {
                if (updateList && updateList.length > 0) {
                    await this.updateDetail(updateList)
                }
            }
            else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.InvalidFieldValuesDetected'),
                    'errorAutoHide'
                );
            }
            this.updatesToSave = []

            if (this.pendingResTimeAlloc)
                this.UpdResTimeAlloc()

            this.saving = false;
        },

        onClick() {
            this.$router.push({ name: 'ScheduleBlockingTimesList' })
        },

        pageDetailChanged(page){
            this.currentDetailPage = page;
            this.GetDetails();
        },

        PerPageDetailFunction(perpage){
            this.perDetailPage = perpage;
            this.currentDetailPage = 1;
            this.GetDetails();
        },

        onRowDetailSelected(rows){
            this.detailSelected = rows;
        },


        async GetDetails() {
                  this.$emit('load', true)
                  let params = {
                    "Groupcreationid":this.$route.params.groupcreationid,
                    "PageSize":  this.perDetailPage,
                    "PageNumber" : this.currentDetailPage,
                    "SearchCriteria": this.DetailSearchCriteria,
                  }
                  await CalendarResTimeAllocationDetails.getAll(params)

                 .then((response) => {
                    if(response.status == '200'){
                        this.detail = response.data;

                        let headerString = response.headers["x-pagination"];
                        this.HeaderDetail = JSON.parse(headerString);
                        this.totalDetailRows = this.HeaderDetail.TotalCount;
                    }
                      this.$emit('load', false);
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        indexOfFromItemRowKey(rowKey) {
            const key = JSON.parse(rowKey);
            return this.detail.findIndex(x =>
                x.recordid == key
            )
        },

        onDetailCellEditComplete(data) {
            const rowIndex = this.indexOfFromItemRowKey(data.rowKey);

            if (rowIndex !== -1) {
                this.detail[rowIndex][data.columnKey] = data.value;
            }

            this.updateValues(data.rowKey)
        },

        async appendDetailRows(rows) {

            rows.forEach(row => {
                this.detail.push({ row });
            });

            rows[0].status = this.$route.params.status
            rows[0].Groupcreationid = this.$route.params.groupcreationid
            rows[0].timefrom = Utils.formatTime(rows[0].timefrom)
            rows[0].timeto = Utils.formatTime(rows[0].timeto)

            this.insertDetail(rows[0])

            return true;
        },

        async GetResTimeAlloc() {
            this.parameter.PageSize = this.perPage;
            this.parameter.DateFrom = this.DateFrom;
            this.parameter.DateTo = this.DateTo;
            await CalendarResTimeAllocations
                .Get(this.$route.params.groupcreationid)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.resTimeAll = response.data;
                        this.Teamcode = this.TherapistList.find(element => element.employeeCode === this.resTimeAll.teamcode);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async UpdResTimeAlloc() {
            await CalendarResTimeAllocations
                .Update(this.$route.params.groupcreationid,this.resTimeAll)
                .then({
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        ChangeDropDownTherapist(therapists){
            this.Teamcode = therapists
            this.resTimeAll.Teamcode = therapists.employeeCode;
        },
    },
      created() {
      },

      async mounted(){
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
          case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
          case 'L1R0':
          case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
          default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        EventBus.$on('onChanged', function(e) {
            this.pendingResTimeAlloc = e.ComponentName == 'Therapist' || e.ComponentName == 'description' ? true : false;
        }.bind(this));

        await this.getEmployees()
        await this.GetResTimeAlloc()
        await this.GetDetails();
      }
    };
</script>
